import { router, usePage } from '@inertiajs/react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import AppTheme from '../../theme/AppTheme';
import AppAppBar from '../Landing/components/AppAppBar';

export default function ThankYou() {
  const { props } = usePage();
  const { name, email, phone } = props;

  const handleBackToHome = () => {
    router.visit('/');
  };

  const firstName = name?.split(' ', 2)[0] ?? 'Visitante';

  return (
    <AppTheme>
      <CssBaseline enableColorScheme />
      <AppAppBar showNavigation={false} />

      <Container maxWidth="md">
        <Box sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          py: 8,
          mt: 8
        }}>
          <Box sx={{
            textAlign: 'center',
            maxWidth: '600px',
            mx: 'auto',
            px: 4
          }}>
            {/* Success Icon */}
            <Box sx={{ mb: 4 }}>
              <CheckCircleIcon
                sx={{
                  fontSize: 80,
                  color: 'success.main',
                  mb: 2
                }}
              />
            </Box>

            {/* Main Title */}
            <Typography
              variant="h3"
              component="h1"
              gutterBottom
              sx={{
                fontWeight: 'bold',
                color: 'text.primary',
                mb: 3
              }}
            >
              Obrigado pelo seu interesse, {firstName}!
            </Typography>

            {/* Description */}
            <Typography
              variant="h6"
              color="text.secondary"
              sx={{
                mb: 4,
                lineHeight: 1.6,
                maxWidth: '500px',
                mx: 'auto'
              }}
            >
              Recebemos sua mensagem e em breve um de nossos consultores entrará em contato através do email{' '}
              <Box component="span" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                {email}
              </Box>
              {phone && (
                <>
                  {' '}ou telefone{' '}
                  <Box component="span" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                    {phone}
                  </Box>
                </>
              )}
              .
            </Typography>

            {/* Back Button */}
            <Button
              variant="contained"
              size="large"
              onClick={handleBackToHome}
              startIcon={<ArrowBackIcon />}
              sx={{
                py: 1.5,
                px: 4,
                borderRadius: 3,
                textTransform: 'none',
                fontSize: '1rem',
                fontWeight: 600,
                boxShadow: 2,
                '&:hover': {
                  boxShadow: 4,
                  transform: 'translateY(-1px)',
                  transition: 'all 0.2s ease-in-out'
                }
              }}
            >
              Voltar para a página inicial
            </Button>

            {/* Additional Info */}
            <Box sx={{ mt: 4, pt: 3, borderTop: 1, borderColor: 'divider' }}>
              <Typography variant="body2" color="text.secondary">
                Você também pode entrar em contato conosco através do email{' '}
                <Box
                  component="a"
                  href="mailto:suporte@drivesync.com.br"
                  sx={{
                    color: 'primary.main',
                    textDecoration: 'none',
                    '&:hover': { textDecoration: 'underline' }
                  }}
                >
                  suporte@drivesync.com.br
                </Box>
              </Typography>
            </Box>
          </Box>
        </Box>
      </Container>
    </AppTheme>
  );
} 